import { render, staticRenderFns } from "./censo-populacao-de-rua.vue?vue&type=template&id=43fcab77&scoped=true&"
import script from "./censo-populacao-de-rua.vue?vue&type=script&lang=js&"
export * from "./censo-populacao-de-rua.vue?vue&type=script&lang=js&"
import style0 from "./censo-populacao-de-rua.vue?vue&type=style&index=0&id=43fcab77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fcab77",
  null
  
)

export default component.exports